import { schema } from 'normalizr';

export const creationSchema = new schema.Entity('creations');

export const creationClipSuggestionSchema = new schema.Entity(
  'creationClipSuggestion',
  {},
  {
    idAttribute: 'suggestionId',
  },
);

export const creationClipSuggestionsSchema = new schema.Entity(
  'creationClipSuggestions',
  { suggestions: [creationClipSuggestionSchema] },
  {
    idAttribute: () => 'clipGroup',
  },
);

export const videoSocialPostCaptionsSchema = new schema.Entity(
  'videoSocialPostCaptions',
  {},
  {
    idAttribute: 'jobId',
  },
);

export const creationSuggestionsProgressSchema = new schema.Entity(
  'creationSuggestionsProgress',
  {},
  {
    idAttribute: () => 'progress',
    processStrategy: entity => ({
      progress: entity.progress,
      status: entity.status,
      estimatedCompletedAt: entity.estimatedCompletedAt,
    }),
  },
);

export const videoZipRequestsByIdSchema = new schema.Entity(
  'videoZipRequestsById',
  {},
  {
    idAttribute: 'id',
  },
);
